import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostPropertyPopComponent } from '@my-component/popup/post-property-pop/post-property-pop.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PostPropertySuccessComponent } from '@my-component/popup/post-property-success/post-property-success.component';
import { StarRaterComponent } from '@my-component/star-rater/star-rater.component';

@NgModule({
  declarations: [
    PostPropertyPopComponent,
    PostPropertySuccessComponent,
    StarRaterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ModalModule.forRoot(),
    NgSelectModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    PostPropertyPopComponent,
    PostPropertySuccessComponent,
    StarRaterComponent,
  ],
})
export class SharedPostingPropertyModule {}
